import { Flex, Modal, Select, Typography } from 'antd';
import { useState } from 'react';

import { LOYALTY_PROGRAM_SENDOUTS, SAVE } from '@app/constants';
import type { AddIntegrationModalProps } from '@app/pages/Notifications/components/RecordsPriorityIntegration/types';
import { SocialIntegrationIcon } from '@app/shared/ui/SocialIntegrationIcon';

const { Text } = Typography;

export const AddIntegrationModal: React.FC<AddIntegrationModalProps> = ({
  isOpen,
  setIsOpen,
  data,
  defaultIntegrations,
  setDefaultIntegrations,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<number[]>([]);

  const handleCancelModal = () => {
    setIsOpen(false);
    setSelectedOptions([]);
  };

  const excludedIds = new Set(defaultIntegrations?.map(({ Id }) => Id) ?? []);

  const selectOptions = [
    ...(data?.AllowedIntegrations
      ? Object.values(
          data.AllowedIntegrations.filter(
            ({ SocialType, Id }) =>
              SocialType !== LOYALTY_PROGRAM_SENDOUTS && !excludedIds.has(Id)
          ).reduce(
            (acc, { BranchId, BranchName, Name, Id, SocialType }) => {
              if (BranchId && !acc[BranchId]) {
                acc[BranchId] = {
                  label: BranchName || 'Без филиала',
                  options: [],
                };
              }

              if (BranchId) {
                acc[BranchId].options.push({
                  label: SocialType ? (
                    <Flex align="center" gap={8}>
                      <SocialIntegrationIcon type={SocialType} size="lg" />
                      <Text>{Name}</Text>
                    </Flex>
                  ) : (
                    Name || `Без названия (ID: ${Id})`
                  ),
                  value: Id,
                  filterName: Name || '',
                });
              }

              return acc;
            },
            {} as Record<
              number,
              {
                label: string | JSX.Element;
                options: {
                  label: string | JSX.Element;
                  value: number;
                  filterName: string;
                }[];
              }
            >
          )
        ).filter((group) => group.options.length > 0)
      : []),
  ];

  const handleChange = (value: number[]) => {
    setSelectedOptions(value);
  };

  const handleOk = () => {
    setDefaultIntegrations((prev) => {
      const newIntegrations = selectedOptions.map((value, index) => ({
        Id: value,
        Order: prev.length + index,
      }));
      return [...prev, ...newIntegrations];
    });
    handleCancelModal();
  };

  return (
    <Modal
      title="Добавить интеграцию"
      open={isOpen}
      onCancel={handleCancelModal}
      onOk={handleOk}
      okText={SAVE}
    >
      <Flex vertical gap={16}>
        <Text>Выберите интеграции</Text>
        <Select
          value={selectedOptions}
          mode="multiple"
          allowClear
          options={selectOptions}
          onChange={handleChange}
          optionFilterProp="filterName"
        />
      </Flex>
    </Modal>
  );
};
